import React from 'react';

import Block from '../Block';

const RenderBlocks = props => {
	const { data, onBlockAction, onChildAction, children } = props;

	const blocks = data.map((block, index) => {
		return (
			<Block
				key={`${block.type}_${block.sort}`}
				block={block}
				index={index}
				children={children}
				onAction={action => onBlockAction(block.type, block.sort, action)}
				onAddAside={b => onBlockAction(b.block.type, b.block.sort, 'aside', 0, 0, b)}
				onAddChild={(group, index) =>
					onBlockAction(block.type, block.sort, 'child', group, index)
				}
				onAsideAction={(type, sort, action, parent) =>
					onBlockAction(type, sort, action, 0, 0, parent, true)
				}
				onChildAction={(type, sort, action, parent) =>
					onBlockAction(type, sort, action, 0, 0, parent)
				}
			/>
		);
	});

	return <React.Fragment>{blocks}</React.Fragment>;
};

export default RenderBlocks;
